import { useState, useEffect, useContext } from "react";
import { useDropdownData } from "./useDropdownData";

import { getStates, getCities, getAreas } from "../../utils/SonicAPIV2";

import GenericCombobox from "./GenericCombobox";

const FIXED_Country = { countryId: 1, countryName: "UAE" };

export default function LocationSelector({
  onLocationChange,
  initialLocationValues, // Accept the initial values as props
}) {
  const [selectedCountry, setSelectedCountry] = useState(
    initialLocationValues?.country || FIXED_Country
  );

  const [selectedState, setSelectedState] = useState(
    initialLocationValues?.state || null
  );

  // const [selectedState, setSelectedState] = useState(FIXED_States);

  const [selectedCity, setSelectedCity] = useState(
    initialLocationValues?.city || null
  );
  const [selectedArea, setSelectedArea] = useState(
    initialLocationValues?.area || null
  );

  // const { data: countries } = useDropdownData(getCountries);

  const countries = [FIXED_Country];

  // useEffect(() => {
  //   //console.log("Countries:", countries);
  //   selectedCountry = FIXED_Country.countryId;
  // }, [countries]);

  const { data: states, loading: statesLoading } = useDropdownData(
    getStates,
    [1],
    [1]
  );

  const { data: cities, loading: citiesLoading } = useDropdownData(
    getCities,
    [selectedState?.stateId],
    [selectedState?.stateId]
  );

  const { data: areas, loading: areasLoading } = useDropdownData(
    getAreas,
    [selectedCity?.cityId],
    [selectedCity?.cityId]
  );

  // Notify parent on any change
  useEffect(() => {
    if (selectedArea) {
      onLocationChange({
        country: selectedCountry,
        state: selectedState,
        city: selectedCity,
        area: selectedArea,
      });
    }
    // console.log("initialLocationValues", initialLocationValues.country);
  }, [selectedCountry, selectedState, selectedCity, selectedArea]);

  // For cities - only fetch when state is selected

  useEffect(() => {
    if (states?.length && initialLocationValues?.state) {
      const match = states.find(
        (s) => s.stateId === initialLocationValues.state.stateId
      );
      if (match) setSelectedState(match);
    }
  }, [states, initialLocationValues]);

  useEffect(() => {
    if (cities?.length && initialLocationValues?.city) {
      const match = cities.find(
        (c) => c.cityId === initialLocationValues.city.cityId
      );
      if (match) setSelectedCity(match);
    }
  }, [cities, initialLocationValues]);

  useEffect(() => {
    if (areas?.length && initialLocationValues?.area) {
      const match = areas.find(
        (a) => a.areaId === initialLocationValues.area.areaId
      );
      if (match) setSelectedArea(match);
    }
  }, [areas, initialLocationValues]);

  return (
    <div className="grid grid-cols-1 w-full gap-x-8 gap-y-1 sm:grid-cols-2">
      <GenericCombobox
        label="Country"
        options={countries}
        selected={selectedCountry}
        onChange={(val) => setSelectedCountry(val)}
        displayKey="countryName"
        disabled={true}
      />

      {states?.length > 0 && (
        <GenericCombobox
          label="State"
          options={states}
          selected={selectedState}
          onChange={(val) => {
            setSelectedState(val);
          }}
          displayKey="statessName"
        />
      )}
      {cities?.length > 0 && (
        <GenericCombobox
          label="City"
          options={cities}
          selected={selectedCity}
          onChange={(val) => setSelectedCity(val)}
          displayKey="cityName"
        />
      )}
      {areas?.length > 0 && (
        <GenericCombobox
          label="Area"
          options={areas}
          selected={selectedArea}
          onChange={(val) => setSelectedArea(val)}
          displayKey="areaName"
        />
      )}
    </div>
  );
}
